<template>
  <div class="form-wrapper">
    
    <div class="box-card">
      <div class="row m-auto">
        <div class="col-md-6 ">
          <div class="form-left text-center p-5">
            <img class="img-fluid" src="@/assets/images/login.png" alt="" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <div class="form-group my-4">
                    <label for="email">Email:</label>
                    <input
                      type="text"
                      v-model="data.email"
                      class="form-control"
                      id="email"
                    />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>

                <ValidationProvider
                  name="password"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="form-group my-4">
                    <label for="password">Password:</label>
                    <input
                      type="password"
                      v-model="data.password"
                      class="form-control"
                      id="password"
                    />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>

                <button type="submit" class="btn">Login</button>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center">
        <span class="text-muted p-0 m-0"
          >© 2022 Barber Sign In. All Right Reserved</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import util from "@/util/util";
export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      data: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    onSubmit() {
    this.isLoading(true);
      util
        .http({
          url: "auth/login",
          method: "post",
          data: this.data,
        })
        .then((res) => {
          if (res) {
            this.isLoading(false);
            this.$notify({
              group: "notifications",
              title: "Logged In",
              type: "success",
              text: res.data.message,
            });

            util.loginUsingToken(res.data.access_token);
            this.fetchPermissions();
          } else {
            this.isLoading(false);

            this.$notify({
              group: "notifications",
              title: "Log In",
              type: "error",
              text: "Credentials do not match",
            });
          }
        });
      // .catch ((error) => {
      //   this.$notify({
      //       group: "notifications",
      //       title: "Log In",
      //       type: "error",
      //       text: error,
      //     });
      // });
    },
    fetchPermissions() {
      util
        .http({
          url: "role/user-permissions",
          method: "get",
        })
        .then((res) => {
          this.$store.commit("setPermissions", res.data.data);
          this.$router.push({ name: "Dashboard" });
        });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
  },
  mounted() {
    if (this.isLoggedIn()) {
      this.$router.push({ name: "Dashboard" });
    }
  },
};
</script>
<style scoped>
.form-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #fff;
}

.box-card {
  box-shadow: 0px 0px 5px 0px rgba(64, 62, 62, 0.75);
  -webkit-box-shadow: 0px 0px 5px 0px rgba(64, 62, 62, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(64, 62, 62, 0.75);
  border: 4px solid #555;
  border-radius: 20px;
}
.form-wrapper .form input {
  border-radius: 0px;
  border: 0;
  border-bottom: 1px solid #555;
}
.form-wrapper .form input:hover {
  transition: all ease 0.5s;
}
.form-wrapper .form input:focus {
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  transition: all ease 0.3s;
}
.form-wrapper .form {
  padding: 2rem;
  width: 100%;
  background: rgba(255, 255, 255);
}
.form-wrapper .form-left {
  background: rgba(255, 255, 255);
  width: 100%;
  height: 100%;
}

.form-wrapper .form .btn {
  background: #54bab9;
  color: #f8f8ff;
  width: 100%;
}
</style>
